// extracted by mini-css-extract-plugin
export default {"contentSide":"content_side_contentSide__ZNgXr"};